import React, {FC, useState} from "react";
import {Charges} from "../../../models/SGB";
import AppUtil from "../../../util/AppUtil";
import AppConstants from "../../../util/AppConstants";
import TickManager, {useSub} from "../../../service/TickManager";
import GatewayService from "../../../service/GatewayService";
import {toast} from "react-hot-toast";
import {Combo} from "../../../models/Combo";

interface Props {
    func : (sort:string)=>void
}

let id = 0

export const ComboHead : FC<Props> = (props) => {
    return<thead>
    <tr>
        {/*<th>analyse</th>*/}
        <th>type</th>
        <th>symbols</th>
        <th>qty</th>
        <th onClick={()=>props.func("capital")}>capital</th>
        <th onClick={()=>props.func("effectiveCapital")}>effectiveCapital</th>
        <th onClick={()=>props.func("time")}>time</th>
        {/*<th onClick={()=>props.func("percentSP")}>percentSP</th>*/}
        <th onClick={()=>props.func("target")}>target</th>
        <th onClick={()=>props.func("effectiveProfit_qty")}>effectiveProfit</th>
        {/*<th>effectiveProfitA</th>*/}
        <th onClick={()=>props.func("absProfit")}>absProfit</th>
        {/*<th onClick={()=>props.func("absProfitA")}>absProfitA</th>*/}
        {/*<th onClick={()=>props.func("buffer")}>buffer</th>*/}
        <th>maxSpreadOption</th>
        <th onClick={()=>props.func("maxSpread")}>maxSpread</th>
        <th onClick={()=>props.func("pointsDiff")}>pointsDiff</th>
        <th onClick={()=>props.func("ytm")}>ytm</th>
        <th onClick={()=>props.func("ytmWithoutMargin")}>ytmWM</th>
        <th onClick={()=>props.func("margin")}>margin</th>
        {/*<th>marginAPI</th>*/}
        <th>taxes</th>
        <th>taxes sqOff</th>
        {/*<th>taxesAPI</th>*/}
        <th onClick={()=>props.func("percentSP")}>percentSP</th>
    </tr>
    </thead>
}

function exec(combo: Combo) {
    GatewayService.exec(combo)
}

function tryToWin(combo: Combo, clientId:string) {
    toast("api in progress")
    GatewayService.tryToWin(combo, clientId).then(msg => toast(msg.first))
}
interface Props2{
    combo:Combo,
    clientId:string
}


export const CombosComp : FC<Props2> = (props) => {
    const row1 = props.combo
    const clientId = props.clientId
    const [time, setTime] = useState(0)
    const [charges, setCharges] = useState<Charges|undefined>()
    let row = AppUtil.fillIn(row1)!
    const days = (row.time / AppConstants.DAY)
    const capital = row.effectiveCapital + (charges?.margin||0.0)
    const interest = days/365*9/100*capital
    let lot = row.qty*row.hiddenLot;

    function getMargin() {
        GatewayService.margin(row).then(setCharges)
    }

    try {
        let arr:Array<string> = [
            row1.buyPut?.genInfo?.tradingsymbol, row1.buyCall?.genInfo?.tradingsymbol, row1.buyFut?.genInfo?.tradingsymbol,
            row1.sellFut?.genInfo?.tradingsymbol, row1.sellPut?.genInfo?.tradingsymbol, row1.sellCall?.genInfo?.tradingsymbol].filter(AppUtil.notEmpty)
    // TickManager.subscribeOptionTick(arr)
        useSub(arr, ()=>setTime(AppUtil.currentTime()))
    // row.percentA = row.minProfitA/row.capital
        const smallDelta = (row.minProfitA - row.minProfit)
        const bigDelta = smallDelta*lot
        const spreadOption = TickManager.getOption(row.maxSpreadOption)
        const maxSpread = row1.maxSpread
        // const maxSpread = AppUtil.minSeller(spreadOption) - AppUtil.maxBuyer(spreadOption)
        let effectiveMarginFromTomorrow = charges? charges.span + charges.exposure : undefined
        let absProfitA = row.absProfit + bigDelta;
        let pointsDiff = row1.pointsDiff
        // let pointsDiff = (row.target-absProfitA)/lot;
        let cssPoints = "red"
        if(maxSpread>pointsDiff)cssPoints = "green"
        let cssWithMargin = "red"
        let cssWithoutMargin = "red"
        let cssMaxSpread = "red"
        if(row.ytm>10 && row.absProfit>0 )cssWithMargin = "green"
        if(row.absProfit>0 && row.effectiveCapital<0)cssWithMargin = "green"
        if(row.ytmWithoutMargin>10 && row.effectiveProfit>0 )cssWithoutMargin = "green"
        if(row.effectiveProfit>0 && row.capital<0)cssWithoutMargin = "green"
        if((row.maxSpreadOption==row.buyPut?.genInfo.tradingsymbol || row.maxSpreadOption==row.buyCall?.genInfo.tradingsymbol) && cssPoints=="green")cssMaxSpread = "green"
        let balanceReq = (row.capital+row.margin)*lot

        let log = ()=> {
            // console.log(`oldYtm : ${row1.ytm.toFixed(2)}, newYTM: ${newYTM.toFixed(2)}, percent : ${row1.percent.toFixed(2)}->${newPercent.toFixed(2)}`)
            let balanceReq = (row.capital+row.margin)*lot
            console.log({api:charges, myData:row1.margin, cssPoints:cssPoints,  cssMaxSpread:cssMaxSpread, balanceReq:balanceReq.toFixed(1),
                text : row.calcText,
                qty : row.qty
            })
            toast(` balance required (${(balanceReq/100000).toFixed(2)})L calc ${row.calcText} qty:${row.qty}`)
            setTime(AppUtil.currentTime())
        }

        let closing = AppUtil.getRoundedOff(row.closing)
        let buyOptionStrike =  row1.buyCall?.genInfo?.strike || row1.buyPut?.genInfo?.strike || 0
        let closingDifference = Math.abs(row.closing - buyOptionStrike)
        if (row.closing==0.0)closing = "";
        else closing = `${closing}(${AppUtil.getRoundedOff(closingDifference)}) : `;
        let callStrike = row1.buyCall?.genInfo?.strike || -1
        let putStrike = row1.buyPut?.genInfo?.strike || -1
        let isCallITM = callStrike==-1 ? false : row.closing>callStrike
        let isPutITM = putStrike==-1 ? false : row.closing<putStrike
        let cssITM = isCallITM||isPutITM ? "green" : "red"
        return <>
            <tr onClick={()=> {log()}} >
                {/*<td><ComboAnalysePopup {...row}/></td>*/}
                <td>{row.type}</td>
                <td className={cssITM}>{  closing +row.symbols + ` ${row.qty}/${row.lot_size}`}</td>
                <td>{row.qty*row.hiddenLot}</td>
                <td>{AppUtil.getRoundedOff(row.capital)}</td>
                <td>{AppUtil.getRoundedOff(row.effectiveCapital)}</td>
                <td onClick={()=>setTime(AppUtil.currentTime())}>{days.toFixed()}</td>
                <td>{AppUtil.getRoundedOff(row.target)}</td>
                <td>{AppUtil.getRoundedOff(row.effectiveProfit_qty)}</td>
                {/*<td>{AppUtil.getRoundedOff(row.effectiveProfit_qty + bigDelta)}</td>*/}
                <td>{AppUtil.getRoundedOff(row.absProfit)}</td>
                {/*<td>{AppUtil.getRoundedOff(row.absProfit+bigDelta)}</td>*/}
                {/*<td>{AppUtil.getRoundedOff(row.buffer+smallDelta)}</td>*/}
                <td className={cssMaxSpread} onClick={()=>tryToWin(row, clientId)}>{(row.maxSpreadOption)}</td>
                <td>{AppUtil.getRoundedOff(maxSpread)}</td>
                <td className={cssPoints}>{AppUtil.getRoundedOff(pointsDiff)}</td>
                <td className={cssWithMargin}>{AppUtil.getRoundedOff(row.ytm)}</td>
                <td className={cssWithoutMargin}>{AppUtil.getRoundedOff(row.ytmWithoutMargin)}</td>
                <td>{row.margin.toFixed(2)}</td>
                {/*<td>{effectiveMarginFromTomorrow?.toFixed(2)}</td>*/}
                <td>{AppUtil.getRoundedOff(row.brokerage)}</td>
                <td>{AppUtil.getRoundedOff(row.brokerageSqOff)}</td>
                {/*<td>{charges?.charges?.toFixed(2)}</td>*/}
                <td>{AppUtil.getRoundedOff(row.percentSP*100)}</td>
                <td>
                    <button onClick={() => exec(row)}>execute({row.instCount})</button>
                </td>
                {/*<td>*/}
                {/*    <button onClick={() => getMargin()}>margin</button>*/}
                {/*</td>*/}
            </tr>
        </>
    }catch (err){
        console.error(err)
        throw err
    }
}




